"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertCorrectPrefixIconSizeInDev = assertCorrectPrefixIconSizeInDev;
function assertCorrectPrefixIconSizeInDev(_ref) {
  var prefixIcon = _ref.prefixIcon,
    size = _ref.size;
  if (!prefixIcon) {
    return;
  }
  if (process.env.NODE_ENV === 'development') {
    var throwOnIncorrectSize = function throwOnIncorrectSize(pixels) {
      var _prefixIcon$name;
      var digitsAtTheEnd = (_prefixIcon$name = prefixIcon.name) === null || _prefixIcon$name === void 0 || (_prefixIcon$name = _prefixIcon$name.match(/\d+$/)) === null || _prefixIcon$name === void 0 ? void 0 : _prefixIcon$name[0];
      if (digitsAtTheEnd && digitsAtTheEnd !== String(pixels)) {
        throw new Error("HBIconButton: If the size is \"".concat(size, "\" the icon must be of size ").concat(pixels, ", received: ").concat(prefixIcon.name));
      }
    };
    switch (size) {
      case 'sm':
        throwOnIncorrectSize(12);
        break;
      case 'md':
        throwOnIncorrectSize(16);
        break;
    }
  }
}
//# sourceMappingURL=HBBaseTag.utils.js.map